import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { VestLtcPageRoutingModule } from './vest-ltc-routing.module';
import { VestLtcPage } from './vest-ltc.page';
import { TranslateModule } from '@ngx-translate/core';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { DropdownModule } from 'src/app/components/dropdown/dropdown.component.module';
import { MatSelectModule } from '@angular/material/select';
import { SafeHtmlsModule } from 'src/app/angular-wallet-base/pipes/safe-htmls/safe-htmls.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    DropdownModule,
    MatSelectModule,
    VestLtcPageRoutingModule,
    SafeHtmlsModule
  ],
  declarations: [VestLtcPage]
})
export class VestLtcPageModule { }
